export function alpha(hex: string, opacity: number = 1): string {
  const sanitizedHex = hex.replace(/^#/, "");

  const fullHex =
    sanitizedHex.length === 3
      ? sanitizedHex
          .split("")
          .map((char) => char + char)
          .join("")
      : sanitizedHex;

  if (fullHex.length !== 6) {
    throw new Error(`Invalid hex color: ${hex}`);
  }

  const r = parseInt(fullHex.substring(0, 2), 16);
  const g = parseInt(fullHex.substring(2, 4), 16);
  const b = parseInt(fullHex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export function adjustLuminance(hex: string, percent: number): string {
  const sanitizedHex = hex.replace(/^#/, "");

  const fullHex =
    sanitizedHex.length === 3
      ? sanitizedHex
          .split("")
          .map((char) => char + char)
          .join("")
      : sanitizedHex;

  if (fullHex.length !== 6) {
    throw new Error(`Invalid hex color: ${hex}`);
  }

  const r = parseInt(fullHex.slice(0, 2), 16);
  const g = parseInt(fullHex.slice(2, 4), 16);
  const b = parseInt(fullHex.slice(4, 6), 16);

  const adjust = (channel: number) => {
    const adjusted = channel + channel * percent;
    return Math.min(255, Math.max(0, Math.round(adjusted)));
  };

  const newR = adjust(r);
  const newG = adjust(g);
  const newB = adjust(b);

  return `#${[newR, newG, newB].map((x) => x.toString(16).padStart(2, "0")).join("")}`;
}

export function lighten(hex: string, percent: number): string {
  return adjustLuminance(hex, percent);
}

export function darken(hex: string, percent: number): string {
  return adjustLuminance(hex, -percent);
}
